<app-page-heading [key]="'local-loads.locations.list.page-title'">
    <button *ngIf="canManageLocations" class="page-heading-right-content btn btn-secondary btn-lg btn-i btn-outline btn-white"
            (click)="openSyncLocation(syncLocationModal)">
        <i class="fa fa-sync-alt"></i>
        <span [i18n]="'local-loads.locations.detail.buttons.sync-plant-location'"></span>
    </button>
</app-page-heading>

<div class="locations-container">
    <app-location-list class="location-list" [(selectedLocation)]="selectedLocation" [synchronizedGlid]="synchronizedGlid"></app-location-list>

    <app-location-detail class="location-detail"
                         [location]="selectedLocation"
                         [canManageLocations]="canManageLocations"
                         (onClose)="closeDetail()">
    </app-location-detail>
</div>

<ng-template #syncLocationModal let-c="close" let-d="dismiss">
    <form id="sync-location-form" class="row">

        <div class="form-group">
            <label for="glid" class="control-label" [i18n]="'local-loads.locations.detail.modals.sync.glid'"></label>
            <input appAutofocus [(ngModel)]="syncForm.glid" class="form-control" id="glid" name="glid" required>
        </div>

    </form>
</ng-template>
